export default [
  {
    path: "/futures",
    name: "ieo",
    redirect: "/futures/startup",
    component: () => import("@/layout/index"),
    children: [
      {
        path: "startup",
        name: "startup", // index
        component: () => import("@/pages/v2/ieo"),
      },
      {
        path: "startup/details",
        name: "details", // details
        component: () => import("@/pages/v2/ieo/details"),
      },
      {
        path: "startup/subscription",
        name: "subscription", // subscription
        component: () => import("@/pages/v2/ieo/subscription"),
      },
    ],
  },
];


// WEBPACK FOOTER //
// ./src/router/v2/ieo/index.js